<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import userApi from '@/api/user'
export default {
    name: 'App',
    data(){
        return {

        }
    },
    created () {
        this.init()
    },
    computed:{
        ...mapGetters({
            getToken : 'getToken',
            getUser : 'getUser',
        }),
    },
    methods: {
        ...mapMutations({
            setToken : 'setToken',
            setUser : 'setUser',
        }),
        init(){
            let token = this.$L.myLocal('token')
            if (token){
                userApi.info().then(res => {
                    if (res.code === 200){
                        this.$L.myLocal('token', res.data.token)
                        this.setUser(res.data)
                    }
                })
            }else {
                this.$router.push({name : "Login"})
            }
        }
    }
}
</script>

<style lang="scss">

* {
    margin: 0;
    padding: 0;
}

html,
body {
    height: 100%;
    font-size: 12px;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}

a {
    color: #409eff;
    text-decoration: none;
}

#app {
    height: 100%;

    // 后台样式开始
    $body_width: 1280px;

    .left_main {
        width: 200px;
        height: calc(100vh - 120px);
        float: left;

        .el-card__body {
            padding: 0;

            .el-menu {
                border-right: 0;
            }
        }
    }

    .right_main {
        width: 1060px;
        height: calc(100vh - 120px);
        float: right;
    }

    // 后台样式结束
    .card-ring {
        padding: 0 10px;
        margin-top: 15px;

        .card-box {
            .title {
                font-size: 14px;

                .line {
                    display: inline-block;
                    width: 3px;
                    height: 15px;
                    background: #409eff;
                    margin: 0 8px 0 0;
                    float: left;
                }
            }
        }
    }

    .loadingbody {
        z-index: 3000;
    }

    .searchbox {
        text-align: right;
        padding: 0 10px;

        .el-input {
            width: 250px;
        }

        .el-select {
            margin-right: 10px;
        }

        .el-button {
            margin-left: 10px;
        }
    }

    .pagebox {
        text-align: right;
        margin-top: 20px;
    }

    .bgred {
        background: #f56c6c;
        color: #fff;
    }
}

#app /deep/ .el-breadcrumb {
    margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue